import { useEffect } from "react";
import { ThemeProvider as NextThemes, useTheme } from "next-themes";
import type { OperatorPublic } from "@ftpedi/contracts";

export function applyBrand(operator: OperatorPublic): void {
  const b = operator.brand;
  const root = document.documentElement;
  root.style.setProperty("--brand-primary", b.primary);
  root.style.setProperty("--brand-accent", b.accent);
  root.style.setProperty("--primary-foreground", readableOn(b.primary) === "white" ? "oklch(0.99 0 0)" : "oklch(0.15 0 0)");
  root.style.setProperty("--radius", b.radius);
  document.title = b.title ?? `${b.name} EDI`;
  const icon = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
  if (icon && b.faviconUrl) icon.href = b.faviconUrl;
}

export function BrandProvider({ operator, children }: { operator: OperatorPublic; children: React.ReactNode }) {
  useEffect(() => applyBrand(operator), [operator]);
  return (
    <NextThemes attribute="class" defaultTheme={operator.brand.theme} enableSystem disableTransitionOnChange>
      {children}
    </NextThemes>
  );
}

export function useBrand(operator: OperatorPublic) {
  const { resolvedTheme } = useTheme();
  const logo = resolvedTheme === "dark" ? (operator.brand.logoDarkUrl ?? operator.brand.logoUrl) : operator.brand.logoUrl;
  return { ...operator.brand, logo: logo ?? null, resolvedTheme };
}

export function readableOn(hex: string): "black" | "white" {
  const n = parseInt(hex.replace("#", ""), 16);
  const r = (n >> 16) & 255;
  const g = (n >> 8) & 255;
  const b = n & 255;
  const lum = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return lum > 0.6 ? "black" : "white";
}
